<template>
    <DelayHydration>
        <section
            class="contact-block"
            :style="{
                '--background-color': backgroundColor,
                '--text-color': textColor
            }"
        >
            <div class="contact-block__wrapper">
                <div class="contact-block__text">
                    <h3
                        v-if="!!$slots.title || pending"
                        class="contact-block__title"
                    >
                        <Skeletor v-if="pending" />
                        <slot
                            v-else
                            name="title"
                        />
                    </h3>

                    <div
                        v-if="!!$slots.description || pending"
                        class="contact-block__description"
                    >
                        <Skeletor v-if="pending" />
                        <slot
                            v-else
                            name="description"
                        />
                    </div>
                </div>

                <div class="contact-block__content">
                    <ContactForm />
                </div>
            </div>
        </section>
    </DelayHydration>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { ColorPalette } from '~/composables/useColorPalette';
import { useColorPalette } from '~/composables/useColorPalette';

const { resolveColor, getTextColor } = useColorPalette();

interface Props {
    backgroundColor?: keyof ColorPalette;
    pending?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    backgroundColor: () => 'cream',
    pending: () => false
});

const backgroundColor = computed(() => resolveColor(props.backgroundColor));
const textColor = computed(() => getTextColor(props.backgroundColor));
</script>

<style lang="less">
.contact-block {
    background-color: var(--background-color);
    color: var(--text-color);
}

.contact-block__wrapper {
    .base-grid(var(--grid-maxWidth-page), false);
    row-gap: var(--spacing-lg);
    padding-block: var(--spacing-xl);

    @media @q-md-min {
        .base-grid-padding(block);
    }
}

.contact-block__text {
    grid-column: first / right-side-gutter;

    @media @q-md-min {
        grid-column: first / left-gutter;
    }
}

.contact-block__title {
    margin-bottom: var(--spacing-md);
}

.contact-block__content {
    grid-column: first / right-side-gutter;

    @media @q-md-min {
        grid-column: second / right-side-gutter;
    }
}
</style>
